import { AccountFeatures, AppContext, Features } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from "react-intl";
import GlobalHelper from '../common/GlobalHelper.jsx';
import Icon from "../common/icon/icon.component.jsx";
import SideBar from '../common/layout/sidebar.component.jsx';
import AnchorWrapper from '../common/rich-text/feature-protection-wrappers/anchorWrapper.component';
import LoadingSpinner from "../common/spinner/loading.component.jsx";
import { getEventName } from '../name-helpers/eventNameHelper';
import { capitalize } from '../name-helpers/nameFormatter';
import AccountStatementListByContact from "./AccountStatementList";
import AccountStatementListByContactOld from "./accountstatementlist.component.jsx";
import CalendarEventListByContact from "./calendareventlist.component.jsx";
import CreditMemoListByContact from "./creditmemolist.component.jsx";
import CustomerInfoView from './info.component.jsx';
import InvoiceListByContact from "./invoicelist.component.jsx";
import OnFileListByContact from "./onfilelist.component.jsx";
import OrderList from "./orderlist.component.jsx";
import QuoteList from './quotelist.component.jsx';
import RecurringInvoiceListByContact from "./recurringinvoicelist.component.jsx";
// TODO : add this import instead when switching to new generic listings
//import InvoiceListByContact from "./InvoiceList";

class CustomerDetails extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            contactId: this.props.match.params.contactId,
            searchKeywords: '',
            activeTab: 'quotes',
            loading: true,
            events: [],
            numberOfUnpaidInvoices: 0,
            numberOfAvailableCreditMemos: 0,
        }

        this.contactId = this.props.match.params.contactId
        this.getTabs = this.getTabs.bind(this)
    }

    componentDidMount() {
        SideBar.activateMenu('contact')
        if (this.props.location.state && this.props.location.state.activeTab) {
            this.setState({
                activeTab: this.props.location.state.activeTab,
                loading: false,
            })
        } else {
            AppContext.getApiClient().get('/users/' + AppContext.getUserLoggedIn().id + '/preferences').then(res => {
                var tabPref = this.getTabs().find(elem => elem.name === res.attributes.contactTab)
                this.setState({
                    activeTab: tabPref ? res.attributes.contactTab : this.state.activeTab,
                    loading: false,
                })
            })
        }
        this.getNumberOfUnpaidInvoices()
        this.getNumberOfAvailableCreditMemos()
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            contactId: nextProps.match.params.contactId
        })
    }

    getNumberOfUnpaidInvoices() {
        let postData = {
            keywords: '*',
            objects: ['invoices'],
            fields: [],
            pageSize: 1,
            activePage: 1,
            sortByField: 'createdAt',
            sortAsc: false,
            filters: {
                contactId: this.state.contactId,
                billingType: ['one-time'],
                status: ['sent', 'partially-paid']
            },
            lightResult: true,
        }

        AppContext.getApiClient().post('/listing/search', postData).then(r => {
            this.setState({
                numberOfUnpaidInvoices: r.metadata.totalItemsCount,
            })
        })
    }

    getTabs() {
        const supportedDocuments = GlobalHelper.getSupportedDocuments()
        return ([
            {
                name: "quotes",
                module: "",
                iconValue: 'quote',
                message: <FormattedMessage
                    id="customers.quotes.list.title_label"
                    defaultMessage="Quotes"
                />,
                excluded: !supportedDocuments.includes('quotes'),
            },
            {
                name: "orders",
                module: AccountFeatures.FeatureOrder,
                iconValue: 'order',
                message: <FormattedMessage
                    id="customers.orders.list.title_label"
                    defaultMessage="Orders"
                />,
                excluded: !supportedDocuments.includes('orders'),
            },
            {
                name: "invoices",
                module: Features.Invoice,
                iconValue: 'invoice',
                message: <FormattedMessage
                    id="customers.invoices.list.title_label"
                    defaultMessage="Invoices"
                />,
                child: this.state.numberOfUnpaidInvoices > 0 &&
                    <span className="ml-1">({this.state.numberOfUnpaidInvoices})</span>,
                excluded: !supportedDocuments.includes('invoices'),
            },
            {
                name: "credit-memos",
                module: "",
                iconValue: 'coins',
                message: <FormattedMessage
                    id="customers.credit_memos.list.title_label"
                    defaultMessage="Credit memos"
                />,
                child: this.state.numberOfAvailableCreditMemos > 0 &&
                    <span className="ml-1">({this.state.numberOfAvailableCreditMemos})</span>,
                excluded: !supportedDocuments.includes('credit-memos'),
            },
            {
                name: "recurring-invoices",
                module: AccountFeatures.FeatureSubscriptions,
                iconValue: 'sync',
                message: <FormattedMessage
                    id="customers.recurring_invoices.list.title_label"
                    defaultMessage="Recurring invoices"
                />,
                excluded: !supportedDocuments.includes('recurring-invoices'),
            },
            {
                name: "account-statements",
                module: AccountFeatures.FeatureAccountStatements,
                iconValue: 'file-invoice',
                message: <FormattedMessage
                    id="customers.account_statements.list.title_label"
                    defaultMessage="Account statements"
                />,
                excluded: !supportedDocuments.includes('account-statements'),
            },
            {
                name: "cards-banks-on-file",
                module: "",
                iconValue: 'credit-card',
                message: <FormattedMessage
                    id="customers.on_file.list.title_label"
                    defaultMessage="Cards/banks on file"
                />,
                excluded: GlobalHelper.hasShopifyIntegrationWithDisabledFeatures(),
            },
            {
                name: "calendar-events",
                module: AccountFeatures.FeatureScheduling,
                iconValue: 'calendar-day',
                message: <FormattedMessage
                    id="customers.calender_events.list_title_label"
                    defaultMessage="{eventName}s"
                    values={{ eventName: capitalize(getEventName(this.props.intl)) }}
                />,
                excluded: !supportedDocuments.includes('events'),
            },
        ])
    }

    getNumberOfAvailableCreditMemos() {
        let postData = {
            keywords: '*',
            objects: ['credit-memos'],
            fields: [],
            pageSize: 1,
            activePage: 1,
            sortByField: 'createdAt',
            sortAsc: false,
            filters: {
                contactId: this.state.contactId,
                status: ['available', 'partially-applied']
            },
            lightResult: true,
        }

        AppContext.getApiClient().post('/listing/search', postData).then(r => {
            this.setState({
                numberOfAvailableCreditMemos: r.metadata.totalItemsCount,
            })
        })
    }

    changeTab(e, tab) {
        this.setState({
            activeTab: tab,
        })
        AppContext.getApiClient().patch('/users/' + AppContext.getUserLoggedIn().id + '/preferences', {
            contactTab: tab
        }).then(_ => {
        })
    }

    render() {
        if (this.state.loading) {
            return <LoadingSpinner />
        }
        const activeClass = 'active'
        let tab = <QuoteList key={0} contactId={this.state.contactId} />
        switch (this.state.activeTab) {
            case "invoices":
                tab = <InvoiceListByContact key={1} contactId={this.state.contactId} />
                break
            case "credit-memos":
                tab = <CreditMemoListByContact key={2} contactId={this.state.contactId} />
                break
            case "recurring-invoices":
                tab = <RecurringInvoiceListByContact key={3} contactId={this.state.contactId} />
                break
            case "account-statements":
                tab = GlobalHelper.shouldEnforceEnvFlag() ?
                    <AccountStatementListByContactOld key={4} contactId={this.state.contactId} /> :
                    <AccountStatementListByContact key={this.state.contactId} contactId={this.state.contactId} />
                break
            case "cards-banks-on-file":
                tab = <OnFileListByContact key={5} contactId={this.state.contactId} />
                break
            case "orders":
                tab = <OrderList key={6} contactId={this.state.contactId} />
                break
            case "calendar-events":
                tab = <CalendarEventListByContact key={7} contactId={this.state.contactId} />
                break
        }

        return (
            <div>
                <CustomerInfoView value={this.state.contactId} className="ui-has-modules" />
                <ul className="nav nav-tabs">
                    {this.getTabs().filter(tab => !tab.excluded).map((elem, index) => {
                        return (
                            <li className="nav-item" key={index}>
                                <AnchorWrapper
                                    module={elem.module}
                                    onClick={(e) => this.changeTab(e, elem.name)}
                                    redirectToAccount={true}
                                    className={"nav-link " + (this.state.activeTab === elem.name ? activeClass : '')}
                                    protectedClassName={"nav-link " + (this.state.activeTab === elem.name ? activeClass : '')}
                                    premium={false}
                                    protectionRule={elem.module === "" ? true : AppContext.accountFeatureIsEnabled(elem.module)}
                                >
                                    <h6 className="p-0 m-0">
                                        <Icon value={elem.iconValue} className={'mr-2'} />
                                        {elem.message}

                                        {elem.child ? elem.child : ""}
                                    </h6>
                                </AnchorWrapper>

                            </li>

                        )
                    })}
                </ul>
                {tab}
            </div>
        );
    }
}

export default injectIntl(CustomerDetails)





// WEBPACK FOOTER //
// ./src/customer/details.component.jsx